import React, { useEffect, useState } from "react";
import {
    Button,
    Card,
    Empty,
    Flex,
    Input,
    Spin,
    Space,
    Skeleton,
    Tooltip,
    message,
    Typography,
    Dropdown,
    Tag,
    Menu,
} from "antd";
import {
    SearchOutlined,
    PlusOutlined,
    EditOutlined,
    ReloadOutlined,
    DeleteOutlined,
    DownOutlined,
    LeftOutlined,
    RightOutlined,
    InboxOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

// ⚠️ Import your actual implementations here
import CreateMaster from "./CreateMaster";
import api from "../../../api";
import RejectionModal from "../Approval/RejectionModal";

const { Title, Text } = Typography;

const Master = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [openCreate, setOpenCreate] = useState(false);
    const [editData, setEditData] = useState(null);
    const [statusFilter, setStatusFilter] = useState("All");
    const [typeFilter, setTypeFilter] = useState("All");
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [messageApi, contextHolder] = message.useMessage();


    const [pageSize, setPageSize] = useState(6);
    const [currentPage, setCurrentPage] = useState(1);
    const navigate = useNavigate();


    useEffect(() => {
        loadData();
    }, []);

    // 🔥 API call directly here
    const loadData = async () => {
        try {
            setLoading(true);

            const payload = {
                "fld_user_id": "admin",
                "synceddatetime": "2025-05-29 10:08:00",
                "formcode": "201",
                "apikey": "kavin",
                "apptypeno": "3",
                "appversion": "1.0.0.0"
            };

            const res = await api.getMasterData(payload); // ⚠️ replace API



            if (res?.data?.status === "1") {
                setData(res.data.ades_data || []);
            }
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async () => {
        if (!selectedItem) return;

        try {
            setLoading(true);

            const payload = {
                fld_rf_id: selectedItem.fld_rf_id,
                synceddatetime: "2025-05-29 10:08:00",
                formcode: "101",
                appversion: "1.0.0.0",
                apikey: "kavin",
                apptypeno: "3",
            };

            const res = await api.deleteMasterData(payload);

            if (res?.data?.status === "1") {
                messageApi.success("Ad deleted successfully");

                loadData();
            } else {
                messageApi.error(
                    res?.data?.responsemessage || "Delete failed"
                );
            }
        } catch (err) {
            console.error(err);

            messageApi.error(
                err?.response?.data?.responsemessage ||
                "Something went wrong"
            );
        } finally {
            setLoading(false);
            setOpenDeleteModal(false);
            setSelectedItem(null);
        }
    };

    const filteredData = data
        .filter((item) => {
            const titleVal = item?.fld_ad_title || "";

            const matchesSearch = titleVal
                .toLowerCase()
                .includes(searchTerm.toLowerCase());

            const matchesStatus =
                statusFilter === "All" ||
                item.fld_ad_status?.toLowerCase() === statusFilter.toLowerCase();

            const matchesType =
                typeFilter === "All" ||
                item.fld_ad_type_name === typeFilter;

            return matchesSearch && matchesStatus && matchesType;
        })
        .sort((a, b) => {
            return new Date(b.fld_form_start_time) - new Date(a.fld_form_start_time);
        });
    const startIndex = (currentPage - 1) * pageSize;
    const paginatedData = filteredData.slice(startIndex, startIndex + pageSize);
    const totalPages = Math.ceil(filteredData.length / pageSize);

    const pageMenu = (
        <Menu
            items={[6, 10, 20].map((num) => ({
                key: num,
                label: num,
                onClick: () => {
                    setPageSize(num);
                    setCurrentPage(1);
                },
            }))}
        />
    );

    const AdvertisementSkeleton = () => (
        <Card>
            <Flex justify="space-between" align="center">

                <Flex gap={16}>
                    <Skeleton.Image
                        active
                        style={{
                            width: 80,
                            height: 80,
                        }}
                    />

                    <div>
                        <Skeleton.Input
                            active
                            size="small"
                            style={{
                                width: 180,
                                height: 16,
                                marginBottom: 8,
                            }}
                        />

                        <div
                            style={{
                                display: "flex",
                                gap: 8,
                                marginBottom: 8,
                            }}
                        >
                            <Skeleton.Button
                                active
                                size="small"
                                style={{ width: 80 }}
                            />
                            <Skeleton.Button
                                active
                                size="small"
                                style={{ width: 70 }}
                            />
                        </div>

                        <Skeleton
                            active
                            title={false}
                            paragraph={{
                                rows: 2,
                                width: ["80%", "60%"],
                            }}
                        />

                        <div
                            style={{
                                display: "flex",
                                gap: 12,
                                marginTop: 6,
                            }}
                        >
                            <Skeleton.Input
                                active
                                size="small"
                                style={{ width: 120 }}
                            />
                            <Skeleton.Input
                                active
                                size="small"
                                style={{ width: 120 }}
                            />
                        </div>
                    </div>
                </Flex>

                <Space>
                    <Skeleton.Button active size="small" />
                    <Skeleton.Button active size="small" />
                </Space>

            </Flex>
        </Card>
    );

    return (
        <>

            {contextHolder}

            {openDeleteModal && (
                <RejectionModal
                    title="Delete Advertisement"
                    content="Are you sure you want to delete this advertisement? This action cannot be undone."
                    buttonName="Delete"
                    open={openDeleteModal}
                    onClose={() => {
                        setOpenDeleteModal(false);
                        setSelectedItem(null);
                    }}
                    onSubmit={handleDelete}
                />
            )}

            <Spin spinning={loading}>
                <div className="review-page">

                    {/* 🔥 Header */}
                    <Flex
                        className="review-header"
                        justify="space-between"
                        align="center"
                        style={{ marginBottom: 16 }}
                    >
                        <Input
                            className="review-search"
                            prefix={<SearchOutlined />}
                            placeholder="Search master..."
                            style={{ width: 300 }}
                            value={searchTerm}
                            onChange={(e) => {
                                setSearchTerm(e.target.value);
                                setCurrentPage(1);
                            }}
                        />

                        <Space>
                            <Button
                                type="primary"
                                icon={<PlusOutlined />}
                                onClick={() => {
                                    setEditData(null);
                                    setOpenCreate(true);
                                }}
                                style={{ background: "#0072b1" }}
                            >
                                Create New Advs.
                            </Button>
                        </Space>
                    </Flex>

                    {/* 🔥 Container */}
                    <div className="review-container">

                        {/* 🔥 Title */}
                        <div className="review-heading">
                            <Title level={4} style={{ margin: 0 }}>
                                Advertisement Management
                            </Title>
                            <Text type="secondary">
                                Manage your Ads
                            </Text>
                        </div>

                        {/* 🔥 Filters */}
                        <div className="review-filters">
                            <div className="filter-buttons">

                                {/* Status Filter */}
                                <Dropdown
                                    overlay={
                                        <Menu
                                            items={[
                                                { key: "All", label: "All", onClick: () => setStatusFilter("All") },
                                                { key: "Draft", label: "Draft", onClick: () => setStatusFilter("draft") },
                                                { key: "Active", label: "Active", onClick: () => setStatusFilter("active") },
                                                { key: "Inactive", label: "Inactive", onClick: () => setStatusFilter("inactive") },
                                            ]}
                                        />
                                    }
                                >
                                    <Button>
                                        Status: {statusFilter} <DownOutlined />
                                    </Button>
                                </Dropdown>

                                {/* Ad Type Filter */}
                                {/* <Dropdown
                                    overlay={
                                        <Menu
                                            items={[
                                                { key: "All", label: "All", onClick: () => setTypeFilter("All") },
                                                { key: "Banner", label: "Banner", onClick: () => setTypeFilter("Banner") },
                                                { key: "Popup", label: "Popup", onClick: () => setTypeFilter("Popup") },
                                                { key: "Card", label: "Card", onClick: () => setTypeFilter("Card") },
                                                { key: "Carousel", label: "Carousel", onClick: () => setTypeFilter("Carousel") },
                                            ]}
                                        />
                                    }
                                >
                                    <Button>
                                        Type: {typeFilter} <DownOutlined />
                                    </Button>
                                </Dropdown> */}

                                {/* Reset */}
                                <Button
                                    icon={<ReloadOutlined />}
                                    onClick={() => {
                                        setSearchTerm("");
                                        setStatusFilter("All");
                                        setTypeFilter("All");
                                        setCurrentPage(1);
                                    }}
                                >
                                    Reset
                                </Button>

                            </div>
                        </div>

                        {/* 🔥 Cards (UNCHANGED) */}
                        <div style={{ display: "grid", gap: 16, marginTop: 16 }}>
                            {loading ? (
                                Array.from({ length: 6 }).map((_, index) => (
                                    <AdvertisementSkeleton key={index} />
                                ))
                            ) : paginatedData.length === 0 ? (
                                <Card>
                                    <Empty
                                        description="No ads data"
                                        image={<InboxOutlined style={{ fontSize: 40 }} />}
                                    />
                                </Card>
                            ) : (
                                paginatedData.map((item) => (
                                    <Card key={item.fld_rf_id} hoverable onClick={() => navigate(`addmaster/${item.fld_rf_id}`, {
                                        state: {
                                            adData: item,
                                        },
                                    })}>
                                        <Flex justify="space-between" align="center">

                                            {/* LEFT */}
                                            <Flex gap={16}>
                                                <img
                                                    src={
                                                        item.fld_image_path ||
                                                        "https://via.placeholder.com/80"
                                                    }
                                                    alt="ad"
                                                    style={{
                                                        width: 80,
                                                        height: 80,
                                                        objectFit: "cover",
                                                        borderRadius: 8,
                                                    }}
                                                />

                                                <div>
                                                    {/* Title + Status */}
                                                    <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
                                                        <Text strong>
                                                            {item.fld_ad_title || "Untitled"}
                                                        </Text>
                                                    </div>

                                                    {/* Tags */}
                                                    <div style={{ marginTop: 6, display: "flex", gap: 10, flexWrap: "wrap" }}>
                                                        {/* <Tag color="blue">{item.fld_ad_type_name}</Tag> */}
                                                        <Tag color="purple">{item.fld_target_screen}</Tag>
                                                        {/* <Tag color="orange">{item.fld_display_position}</Tag> */}
                                                        <Tag
                                                            color={
                                                                item.fld_ad_status?.toLowerCase() === "active"
                                                                    ? "green"
                                                                    : item.fld_ad_status?.toLowerCase() === "inactive"
                                                                        ? "red"
                                                                        : item.fld_ad_status?.toLowerCase() === "draft"
                                                                            ? "blue"
                                                                            : "purple"
                                                            }
                                                        >
                                                            {item.fld_ad_status}
                                                        </Tag>

                                                    </div>

                                                    {/* Description */}
                                                    <div style={{ color: "#888", maxWidth: 400 }}>
                                                        <div
                                                            style={{
                                                                display: "-webkit-box",
                                                                WebkitLineClamp: 2,
                                                                WebkitBoxOrient: "vertical",
                                                                overflow: "hidden",
                                                            }}
                                                        >
                                                            {item.fld_ad_description || "No description"}
                                                        </div>
                                                    </div>

                                                    {/* Bottom row */}
                                                    <div style={{ marginTop: 6, display: "flex", gap: 10 }}>
                                                        <Text type="secondary">
                                                            Start: {item.fld_start_date}
                                                        </Text>

                                                        <Text type="secondary">
                                                            End: {item.fld_end_date}
                                                        </Text>
                                                    </div>
                                                </div>
                                            </Flex>

                                            {/* RIGHT ACTIONS */}
                                            <Space>
                                                <Tooltip title="Edit">
                                                    <Button
                                                        icon={<EditOutlined />}
                                                        size="small"
                                                        onClick={(e) => {
                                                            e.stopPropagation(); // ✅ IMPORTANT
                                                            setEditData(item);
                                                            setOpenCreate(true);
                                                        }}
                                                    >
                                                        Edit
                                                    </Button>
                                                </Tooltip>

                                                <Tooltip title="Delete">
                                                    <Button
                                                        icon={<DeleteOutlined />}
                                                        danger
                                                        size="small"
                                                        onClick={(e) => {
                                                            e.stopPropagation();

                                                            setSelectedItem(item);
                                                            setOpenDeleteModal(true);
                                                        }}
                                                    >
                                                        Delete
                                                    </Button>
                                                </Tooltip>
                                            </Space>

                                        </Flex>
                                    </Card>
                                ))
                            )}
                        </div>

                        {/* 🔥 Pagination */}
                        <Flex
                            justify="center"
                            align="center"
                            gap={10}
                            style={{ marginTop: 20 }}
                        >
                            <Button
                                icon={<LeftOutlined />}
                                disabled={currentPage === 1}
                                onClick={() => setCurrentPage((p) => p - 1)}
                            />

                            <span>
                                Page {currentPage} of {totalPages || 1}
                            </span>

                            <Button
                                icon={<RightOutlined />}
                                disabled={currentPage === totalPages}
                                onClick={() => setCurrentPage((p) => p + 1)}
                            />

                            <Dropdown overlay={pageMenu}>
                                <Button>
                                    {pageSize} / page <DownOutlined />
                                </Button>
                            </Dropdown>
                        </Flex>
                    </div>

                    {/* 🔥 Modal */}
                    {openCreate && (
                        <CreateMaster
                            visible={openCreate}
                            editdata={editData}
                            onCancel={() => {
                                setOpenCreate(false);
                                setEditData(null);
                            }}
                            onSuccess={() => {
                                setOpenCreate(false);
                                setEditData(null);
                                loadData();
                            }}
                        />
                    )}

                </div>
            </Spin>
        </>
    );
};

export default Master;